module.exports = __webpack_public_path__ + "img/_nav.3fb63120.png";